<div class="other-layout-flex-content">
  <router-outlet></router-outlet>
  <ngx-spinner name="other-layout-spinner" size="default" [fullScreen]="true" type="line-spin-clockwise-fade"></ngx-spinner>
</div>
